module.exports = __webpack_public_path__ + "img/catskill_creek.45d18a73.jpg";